/*
 *
 * Validate Form
 *
 * */
const validate = (values) => {
  const errors = {};

  if (!values.addressInfo) {
    errors.general = "Please Choose a location to continue";
  }

  return errors;
};

export default validate;
